import VerifiedIcon from "@mui/icons-material/Verified";
import React from "react";
import { ButtonProps } from "@mui/material";

type BadgeVerificationIconProps = ButtonProps;

export const BadgeVerificationIcon = ({ sx }: BadgeVerificationIconProps) => {
  return <VerifiedIcon sx={sx} className={`w-5 h-5`} />;
};
